import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, pushAttributionReady } from "../lib/attribution";

// Runs on the initial page load AND every client-side route change:
// captures marketing parameters when the URL carries them (internal navigation
// without marketing params never overwrites stored attribution) and publishes
// the analytics-safe marketing_attribution_ready event to the GTM data layer.
export function AttributionTracker() {
  const location = useLocation();
  useEffect(() => {
    captureAttribution(location.search);
    pushAttributionReady();
  }, [location.pathname, location.search]);
  return null;
}
